<span class="filters__showMoreButton" (click)="emitToggleShowMore()">
  <span *ngIf="isShowingMore" i18n="@@CATALOG.FILTERS.INPUT.LABELS.LESS">Show less</span>
  <span *ngIf="!isShowingMore" i18n="@@CATALOG.FILTERS.INPUT.LABELS.MORE">See more</span>
  <span class="{{ isShowingMore ? 'arrow-up' : 'arrow-down' }}"></span>
</span>
